import "./FoodStatusBadge.css";

function FoodStatusBadge({ isAvailable }) {
  return (
    <span
      className={
        isAvailable
          ? "food-status available"
          : "food-status unavailable"
      }
    >
      {isAvailable ? "Available" : "Unavailable"}
    </span>
  );
}

export default FoodStatusBadge;